// extracted by mini-css-extract-plugin
export default {"pageTitle":"BasicHeader_pageTitle__GH+Px"};